import { cx } from "@jugl-web/utils";
import { FC } from "react";

interface ProductQuantitySelectProps {
  quantity: number;
  maxQuantity: number | null;
  onQuantityChange: (quantity: number) => void;
}

export const ProductQuantitySelect: FC<ProductQuantitySelectProps> = ({
  quantity,
  maxQuantity,
  onQuantityChange,
}) => {
  const handleDecrement = () => {
    if (quantity > 1) {
      onQuantityChange(quantity - 1);
    }
  };

  const handleIncrement = () => {
    onQuantityChange(quantity + 1);
  };

  const isMinQuantityReached = quantity <= 1;
  const isMaxQuantityReached = maxQuantity !== null && quantity >= maxQuantity;

  return (
    <div className="flex flex-col gap-1">
      <span className="px-2 font-secondary text-[13px] leading-[140%] font-normal text-dark-700">
        Quantity:
      </span>
      <div className="flex h-[42px] items-center justify-center rounded-3xl border border-solid border-grey-300">
        <ProductQuantitySelectButton
          symbol="-"
          ariaLabel="Decrease quantity"
          onClick={handleDecrement}
          isDisabled={isMinQuantityReached}
        />
        <span className="mx-1.5 w-[80px] shrink-0 truncate text-center font-secondary text-sm leading-[150%] font-medium text-dark">
          {quantity}
        </span>
        <ProductQuantitySelectButton
          symbol="+"
          ariaLabel="Increase quantity"
          onClick={handleIncrement}
          isDisabled={isMaxQuantityReached}
        />
      </div>
    </div>
  );
};

interface ProductQuantitySelectButtonProps {
  symbol: "+" | "-";
  ariaLabel: string;
  isDisabled?: boolean;
  onClick: () => void;
}

const ProductQuantitySelectButton: FC<ProductQuantitySelectButtonProps> = ({
  symbol,
  ariaLabel,
  isDisabled = false,
  onClick,
}) => (
  <button
    type="button"
    aria-label={ariaLabel}
    disabled={isDisabled}
    className={cx(
      "jugl__focusable-outline flex h-8 w-8 shrink-0 items-center justify-center rounded-md",
      "cursor-pointer border-0 bg-transparent font-secondary text-[22px] text-[#A7AEB0] transition",
      "hover:bg-grey-100 active:bg-grey-200",
      "disabled:cursor-not-allowed disabled:text-[#E0E2E3] disabled:hover:bg-transparent"
    )}
    onClick={onClick}
  >
    {symbol}
  </button>
);
